import React from 'react';
import { Link } from 'react-router-dom';
import InternalLinks from './home/InternalLinks';
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  Award,
  Facebook,
  ExternalLink,
  Shield,
  Star,
  BadgeCheck,
  Building2,
  Scale,
} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <InternalLinks />
      <footer className="bg-gradient-to-b from-dk-dark-blue via-dk-blue to-dk-blue text-white">
        <div className="container mx-auto px-4 pb-12">
          {/* Trust Badges Section */}
          <div className="mb-10 border-b border-white/20 pt-10 pb-8">
            <div className="text-center mb-6">
              <h3 className="text-lg font-semibold mb-1">Ils nous font confiance</h3>
              <p className="text-white/80 text-sm">Certifications et accréditations</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 items-center justify-items-center">
              <div className="flex flex-col items-center text-center p-3 bg-white/10 rounded-lg hover:bg-white/20 transition-colors">
                <BadgeCheck className="h-10 w-10 mb-2 text-white" />
                <span className="font-medium text-sm">Diagnostiqueur Certifié</span>
                <span className="text-xs text-white/80">Certification DPE</span>
              </div>
              <div className="flex flex-col items-center text-center p-3 bg-white/10 rounded-lg hover:bg-white/20 transition-colors">
                <Scale className="h-10 w-10 mb-2 text-white" />
                <span className="font-medium text-sm">Assurance RCP</span>
                <span className="text-xs text-white/80">Garantie professionnelle</span>
              </div>
              <div className="flex flex-col items-center text-center p-3 bg-white/10 rounded-lg hover:bg-white/20 transition-colors">
                <Star className="h-10 w-10 mb-2 text-white" />
                <span className="font-medium text-sm">Note 4.9/5</span>
                <span className="text-xs text-white/80">Avis clients vérifiés</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Diagnostics */}
            <div>
              <h3 className="text-base font-semibold mb-4 border-b border-white/20 pb-2">
                Nos diagnostics immobiliers
              </h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/services" className="hover:text-white/80 transition-colors">DPE – Diagnostic de Performance Énergétique</Link></li>
                <li><Link to="/audit-energetique" className="hover:text-white/80 transition-colors">Audit Énergétique (classes E, F, G)</Link></li>
                <li><Link to="/services" className="hover:text-white/80 transition-colors">Diagnostic Électricité</Link></li>
                <li><Link to="/services" className="hover:text-white/80 transition-colors">Diagnostic Gaz</Link></li>
                <li><Link to="/services" className="hover:text-white/80 transition-colors">Diagnostic Amiante</Link></li>
                <li><Link to="/services" className="hover:text-white/80 transition-colors">Diagnostic Plomb (CREP)</Link></li>
                <li><Link to="/services" className="hover:text-white/80 transition-colors">Loi Carrez – Mesurage Vente</Link></li>
                <li><Link to="/services" className="hover:text-white/80 transition-colors">Loi Boutin – Mesurage Location</Link></li>
                <li><Link to="/services" className="hover:text-white/80 transition-colors">État des Risques et Pollutions (ERP)</Link></li>
              </ul>
            </div>

            {/* Zones d'intervention + Infos */}
            <div>
              <h3 className="text-base font-semibold mb-4 border-b border-white/20 pb-2">
                Zones d'intervention
              </h3>
              <ul className="space-y-2 text-sm mb-6">
                <li><Link to="/diagnostic-valence-drome" className="hover:text-white/80 transition-colors">Diagnostic immobilier Valence Drôme</Link></li>
                <li><Link to="/diagnostic-ardeche-saint-peray" className="hover:text-white/80 transition-colors">Diagnostic immobilier Ardèche – Saint-Péray</Link></li>
                <li><Link to="/diagnostic-orange-vaucluse" className="hover:text-white/80 transition-colors">Diagnostic immobilier Orange Vaucluse</Link></li>
                <li><Link to="/diagnostic-avignon-region" className="hover:text-white/80 transition-colors">Diagnostic immobilier Avignon et région</Link></li>
              </ul>

              <h3 className="text-base font-semibold mb-4 border-b border-white/20 pb-2">
                Informations
              </h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/realisations" className="hover:text-white/80 transition-colors">Nos réalisations</Link></li>
                <li><Link to="/#devis" className="hover:text-white/80 transition-colors">Demander un devis gratuit</Link></li>
                <li><Link to="/mentions-legales" className="hover:text-white/80 transition-colors">Mentions légales</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-base font-semibold mb-4 border-b border-white/20 pb-2">Contact</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start space-x-3">
                  <Phone className="h-4 w-4 text-white mt-0.5" />
                  <div>
                    <p className="font-medium">Téléphone</p>
                    <a href="tel:0789307500" className="hover:text-white/80 transition-colors">07 89 30 75 00</a>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <Mail className="h-4 w-4 text-white mt-0.5" />
                  <div>
                    <p className="font-medium">Email</p>
                    <a href="mailto:Spskdiag@gmail.com" className="hover:text-white/80 transition-colors">Spskdiag@gmail.com</a>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <MapPin className="h-4 w-4 text-white mt-0.5" />
                  <div>
                    <p className="font-medium">Adresse</p>
                    <p>95 avenue Fernand Gonnet</p>
                    <p>84850 Camaret-sur-Aigues</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <Clock className="h-4 w-4 text-white mt-0.5" />
                  <div>
                    <p className="font-medium">Horaires</p>
                    <p>Lun-Ven: 8h-19h</p>
                    <p>Sam: Sur rendez-vous</p>
                  </div>
                </li>
              </ul>

              <div className="mt-5 flex items-center gap-3">
                <a
                  href="https://www.facebook.com/SarlDgK"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook className="h-4 w-4" />
                </a>
                <a href="tel:0789307500" className="btn bg-white/10 hover:bg-white/20 flex items-center justify-center text-sm">
                  Nous contacter
                  <Phone className="h-4 w-4 ml-2" />
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-white/20 mt-8 pt-5 text-center text-xs text-white/70 space-y-2">
            <p>
              &copy; {currentYear} DIAGNOSTI-K SARL – 95 avenue Fernand Gonnet, 84850 Camaret-sur-Aigues – 07 89 30 75 00 – Vaucluse (84), Drôme (26), Gard (30), Bouches-du-Rhône (13)
            </p>
            <p>
              <a
                href="https://easywebcreation.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white/80 transition-colors"
              >
                Créé par easywebcreation.fr
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
